const isMixPanelAvailable = () => typeof (window as any).mixpanel !== 'undefined' && (window as any).mixpanel.__loaded;

export const reset = () => {
    return new Promise<void>((resolve) => {
        if (!isMixPanelAvailable()) {
            console.info("Mixpanel didn't load");

            return resolve();
        }

        (window as any).mixpanel.reset();
        resolve();
    });
};

export const alias = (userId: string) => {
    return new Promise<void>((resolve) => {
        if (!isMixPanelAvailable()) {
            console.info("Mixpanel didn't load");

            return resolve();
        }

        (window as any).mixpanel.alias(userId);
        setTimeout(resolve, 500);
    });
};

export const identify = (userId: string) => {
    return new Promise<void>((resolve) => {
        if (!isMixPanelAvailable()) {
            console.info("Mixpanel didn't load");

            return resolve();
        }

        (window as any).mixpanel.identify(userId);
        setTimeout(resolve, 500);
    });
};

export const track = (label: 'Web' | 'App' | 'Credentials', category: string, action: string, options: any = {}) => {
    return new Promise<void>((resolve) => {
        if (!isMixPanelAvailable()) {
            console.info("Mixpanel didn't load");

            return resolve();
        }

        (window as any).mixpanel.track(`${label} ${category} ${action}`, options, resolve);
    });
};
